import { omit } from 'underscore';

import { SubmitConfig } from 'containers/ProjectWizards/EpisodeWizard/types';
import { exportFromWizard } from 'redux/modules/wizard-export/actions';
import { ThunkAction } from 'redux/types';

import { Type } from './action-types';
import { entireAudioEnhancer } from './enhancers';

export const createEpisode = (
  config: SubmitConfig,
): ThunkAction<Promise<void>> => async (dispatch, getState) => {
  const { frameSizeOverride, transcription } = config;

  const entireAudioInstanceId = entireAudioEnhancer.selectors.entireAudioInstanceIdSelector(
    getState(),
  );

  await dispatch(
    exportFromWizard({
      ...omit(
        config,
        'audioSource',
        'audioSourceType',
        'originalAudioUrl',
        'frameSizeOverride',
      ),
      audio: {
        entireAudioInstanceId,
      },
      fullEpisodeExport: true,
      initiateExport: true,
      projectCreatMethod: 'episode',
      soundwave: {
        waveGeneration: 'amplitudeBased',
        ...config.soundwave,
      },
      transcription: {
        transcribe: transcription.transcribe,
        transcriptUrl: undefined,
        language: transcription.language,
      },
      frameSizeOverride,
    }),
  );
};

export const clearEpisodeWizard = (): ThunkAction<void> => dispatch => {
  dispatch(entireAudioEnhancer.actions.cancelPolling());
  dispatch({ type: Type.EPISODE_WIZARD_CLEAR });
};

export const {
  clearEntireAudio,
  uploadEntireAudio,
} = entireAudioEnhancer.actions;
